
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/motorcycle-events",
      function () {
        return require("private-next-pages/motorcycle-events.js");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/motorcycle-events"])
      });
    }
  